import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpInterceptor as NgHttpInterceptor,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
/**
 * Adds default headers to every request made with httpClient
 */
export class HttpInterceptor implements NgHttpInterceptor {
  // default headers to add to any request
  headers: any = {
    'content-type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*'
    };
  constructor() {}

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const modifiedHttpRequest: any = httpRequest.clone({
      setHeaders: this.headers,
    });

    return next.handle(modifiedHttpRequest);
  }
}
